var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"scroll-to-top",attrs:{"aria-label":"Torna in alto"},on:{"click":_vm.scrollToTop}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-chevron-up")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }